import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux';

import * as drawer from './modules/drawer';
import * as events from './modules/events';
import * as faq from './modules/faq';
import * as language from './modules/language';
import * as registration from './modules/registration';
import * as rules from './modules/rules';
import * as windowModule from './modules/window';

// modules
export default (history: any) =>
  combineReducers({
    drawer: drawer.reducer,
    events: events.reducer,
    faq: faq.reducer,
    language: language.reducer,
    registration: registration.reducer,
    router: connectRouter(history),
    rules: rules.reducer,
    window: windowModule.reducer
  });



// WEBPACK FOOTER //
// ./src/store/createRootReducer.ts